import React from 'react'
import ReactDOM from 'react-dom'
import { debounce, unset } from 'lodash'

import Label from 'Components/control-label'
import Select from 'Components/select'
import Toolbar from 'Components/toolbar'
import ColorPalette from 'Components/color-palette'
import FontSelector from 'Components/font-selector'
import UploadButton from 'Components/upload-button'
import SliderControl from 'Components/slider'
import ResponsiveValueNotice from 'Components/responsive-value-notice'

import getDefaultValue from 'Functions/get-default-value'
import addCssRule from 'Functions/add-css-rule'
import { getCssValue } from 'Functions/get-css-value'
import isCssRuleApplied from 'Functions/is-css-rule-applied'
import { changeCssValueWithPostCSS } from 'Functions/on-option-change'
import CodeManager from 'Functions/code-manager'

/* Import CSS */
import './index.scss'

class Control extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isVisible: true,	// Used to hard-update/re-render controls.
			isDefault: false,	// inherit/none/etc.
			isEnabled: false,
			isResponsiveNotice: false,
			currentValue: false,
			currentUnit: '',
		}
	}

	isEnabled = () => {
		return this.state.isEnabled
	}

	currentValue = () => {
		return this.state.currentValue
	}

	currentUnit = () => {
		return this.state.currentUnit
	}

	getValueWithUnit = () => {
		const value = this.state.currentValue
		let unit = this.state.currentUnit
		if ( false === unit ) {
			unit = ''
		}

		return value + unit
	}

	onInputChange = ( event ) => {
		this.changeValue( event.target.value )
	}

	toggleDefault = () => {
		const { type, cssProperty, selectedEl, cssDefault } = this.props;

		if ( this.state.isDefault ) {
			const cssValue = getDefaultValue( cssProperty, type, true )

			if ( this.state.currentValue !== cssValue ) {
				this.changeValue( cssValue )
			} else {
				this.setState( { isDefault: false } )
			}
		} else {
			this.changeValue( this.props.cssDefault )
		}
	}

	toggleEnabled = () => {
		const editorCSS = CodeManager.getCode()
		const currentSize = window.stlst_legacy.get_media_condition()
		// If going to disable control - delete CSS.
		if ( this.state.isEnabled ) {
			changeCssValueWithPostCSS( editorCSS, {
				css: this.props.cssProperty,
				current: false,
				selector: this.props.cssSelectorCustom,
				size: currentSize,
			} )
		}

		this.setState( {
			isEnabled: ! this.state.isEnabled,
		} )

		// Remove from CSS values cache.
		unset( window.Stylist.cachedCssValues, '["' + this.props.cssSelectorCustom + '"]["' + currentSize + '"].' + this.props.cssProperty )
	}

	changeValue = ( value ) => {
		const { selectedEl, cssProperty } = this.props;

		if ( this.state.isEnabled ) {
			window.stlst_legacy.delete_live_css()
			window.stlst_legacy.insert_live_css( cssProperty, value + this.state.currentUnit ) //, custom)
		}

		if ( ! this.state.isEnabled ) {
			this.changeValueInstant( value )
		} else {
			this.changeValueThrottled( value )
		}
	}

	changeValueInstant = ( value ) => {
		if ( undefined === value ) {
			value = false
		}

		// Basic value validation.
		if ( '-' === value || '' === value ) {
			return
		}

		if ( value === this.props.cssDefault ) {
			// If clicked RESET TO DEFAULT button (inherit/none/etc).
			this.setState( {
				currentValue: value,
				currentUnit: this.currentUnit(), //'',
				isDefault: true,
			} )
		} else if ( 'slider' === this.props.type ) {
			// If slider - value needs data/unit separation.
			let newValue = false,
				newUnit = this.currentUnit()

			if ( 'string' === typeof value ) { // && isNaN( value )
				if ( value.includes( 'px' ) ) {
					newValue = parseFloat( value.replace( 'px', '' ) )
					newUnit = 'px'
				} else if ( value.includes( '%' ) ) {
					newValue = parseFloat( value.replace( '%', '' ) )
					newUnit = '%'
				} else if ( value.includes( 'em' ) ) {
					newValue = parseFloat( value.replace( 'em', '' ) )
					newUnit = 'em'
				} else if ( value.includes( 'vh' ) ) {
					newValue = parseFloat( value.replace( 'vh', '' ) )
					newUnit = 'vh'
				} else if ( 'line-height' === this.props.cssProperty ) {
					// Line height with relative value (empty unit)
					newValue = parseFloat( value )
					newUnit = ''
				}
			} else if ( 'number' === typeof value && isNaN( value ) ) {
				newValue = this.state.currentValue
				// this.setState( { isDefault: true } )
			} else if ( undefined !== newValue ) {
				newValue = value
				if ( 0 === newValue && ! newUnit &&
						'line-height' !== this.props.cssProperty ) {
					newUnit = 'px'
				}
			}

			if ( 'font-weight' === this.props.cssProperty ) {
				newUnit = ''
			}

			this.setState( {
				currentValue: newValue,
				currentUnit: newUnit,
				isDefault: false,
			} )
		} else if ( 'upload' === this.props.type ) {
			if ( 6 < value.length ) {
				this.setState( {
					currentValue: value,
					currentUnit: '',
					isDefault: false,
				} )
			}
		} else {
			// If not a slider – just update state.
			this.setState( {
				currentValue: value,
				isDefault: false,
			} )
		}
	}

	/**
	 * Change control value.
	 *
	 * @param {string/number} value Value with unit in a string ex: '18px'.
	 */
	// changeValue = ( value ) => {
	changeValueThrottled = debounce( ( value ) => {
		this.changeValueThrottled.cancel()
		this.changeValueInstant( value )
	}, 1000, {
		leading: false,
		trailing: true
	} )

	changeUnit = ( newValue ) => {
		this.setState( { currentUnit: newValue } )
	}

	componentWillMount = () => {
		// Get fired when you click to open dropdown panel.
		// This is time when we need to set value based on currently selected element.
		const { type, cssProperty, selectedEl, cssDefault } = this.props;

		// Param: type – Control type. ex: color
		let cssValue = getDefaultValue( cssProperty, type );

		if ( undefined !== cssValue ) {
			this.changeValue( cssValue )
		}
		// Set control status: enabled/disabled.
		const selector = window.Stylist.cssSelectorCustom
		// Checks if there is custom/generated css for provided slectector+property.
		const responsiveSize = window.stlst_legacy.get_media_condition()
		const cssCode = CodeManager.getCode()

		let status = getCssValue( {
			cssSelector: selector,
			cssProperty: cssProperty,
			responsiveSize: responsiveSize
		} )

		// If any value set – true.
		if ( false !== status ) {
			status = true
		}

		if ( status ) {
			this.setState( { isEnabled: true }, () => {
				// Then...
				this.updateResponsiveNotice()
			} )
		}

		if ( cssValue === cssDefault ) {
			this.setState( { isDefault: true } )
		}

		/**
		 * When user draggs element boudaries to visually change
		 * margin/padding/width/height we need to update the slider controls accordingly.
		 * The sliders get value from the parrent only on initial render,
		 * so we need to rerender it completely to have it updated properly
		 * following the visuall (dragg) changes.
		 *
		 * We can't make sliders state dependable as sometimes users want to have
		 * cssProperty values outside of the slider range.
		 *
		 * window.Stylist.reRenderControl is an object with dynamic functions inside.
		 * Each inner function name is eaqual to the cssProperty of the control
		 * that needs to be updated.
		 *
		 * window.Stylist.reRenderControl = {
		 * 	- paddingtop
		 *  - paddingrigth
		 *  ...
		 * }
		 *
		 */
		if ( undefined === window.Stylist.reRenderControl ) {
			window.Stylist.reRenderControl = {}
		}

		// Transfrom 'padding-top' to 'paddingtop' as function name can't contain hyphens.
		const cssPropertyJS = cssProperty.replace( '-', '' );

		// Firstly check if it wasn't already created during the previous component renders.
		if ( undefined === window.Stylist.reRenderControl[ cssPropertyJS ] ) {
			// Add dynamic functions inside to have something like this:
			// window.Stylist.reRenderControl.paddingtop()
			window.Stylist.reRenderControl[ cssPropertyJS ] = () => {
				// Get CSS value from the page code.
				cssValue = getDefaultValue( cssProperty, this.props.type )
				if ( undefined !== cssValue ) {
					this.changeValue( cssValue )
					// Destroy control completely.
					this.setState( {
						isVisible: false
					} )
					// Crete it again.
					this.setState( {
						isVisible: true
					} )
					/**
					 * Standard React tools like
					 * this.forceUpdate() or this.setState(this.state)
					 * will not help in this situation.
					 */
				}
			}
		}
	}

	updateResponsiveNotice = () => {
		/**
		 * Once all done and CSS if in the main code block,
		 * check again if it works or it gets overriten by other code (like: media queries).
		 */
		if ( this.state.isEnabled &&
			! isCssRuleApplied( this.props.cssProperty, this.getValueWithUnit() ) ) {
			// @todo: check with regex here is we have mediaquery or it's just other code.
			// IF mediaquery
			this.setState( {
				isResponsiveNotice: true
			} )
			// IF other code...
		} else if ( this.state.isEnabled && this.state.isResponsiveNotice ) {
			this.setState( {
				isResponsiveNotice: false
			} )
		}
	}

	/**
	 * Delete window.Stylist.reRenderControl functions for the current
	 * control when it's not visible/mounted, so other functions know
	 * that it makes no sense to call it on margin/padding resize.
	 */
	componentWillUnmount = () => {
		const { type, cssProperty, selectedEl } = this.props
		// Transfrom 'padding-top' to 'paddingtop' as function name can't contain hyphens.
		const cssPropertyJS = cssProperty.replace( '-', '' )
		window.Stylist.reRenderControl[ cssPropertyJS ] = undefined
	}

	componentDidUpdate = ( prevProps, prevState ) => {
		let controlBeingEnabled = false

		if ( this.state.isEnabled && ! prevState.isEnabled ) {
			controlBeingEnabled = true
		}

		if ( this.state.currentValue !== prevState.currentValue ||
			this.state.currentUnit !== prevState.currentUnit ||
			controlBeingEnabled ) {
			// Enable element if the value changed and
			// it's not default ('none'/'inherit').
			if ( ! this.state.isEnabled &&
				this.state.currentValue !== this.props.cssDefault ) {
				this.setState( {
					isEnabled: true
				} )
				controlBeingEnabled = true
			}

			if ( this.state.isEnabled || controlBeingEnabled ) {
				// Some properties needs a fast visuall feedback (sliders, colors)
				// so we push simplified fast changes before updating main CSS code.
				if ( 'slider' === this.props.type || 'color' === this.props.type ) {
					this.pushCSSChangesFast() // Only slider value change – quick update.
				} else {
					this.pushCSSChangesThrottled()
				}
			}
		}
	}

	pushCSSChangesFast = () => {
		const { selectedEl, cssProperty, cssSelectorCustom, cssCurrentPseudoClass, cssSelectorFull } = this.props;

		window.stlst_legacy.delete_live_css()
		window.stlst_legacy.insert_live_css( cssProperty, this.state.currentValue + this.state.currentUnit ) //, custom)

		if ( 'border-width' === cssProperty || 'border-top-width' === cssProperty || 'border-right-width' === cssProperty || 'border-bottom-width' === cssProperty || 'border-left-width' === cssProperty ) {
			const responsiveSize = window.stlst_legacy.get_media_condition()
			// let borderStyle = getDefaultValue( 'border-style', type );
			const styleAllSides = getCssValue( {
				cssSelector: cssSelectorCustom,
				cssProperty: 'border-style',
				responsiveSize: responsiveSize
			} )

			let styleThisSide = false

			if ( ! styleAllSides && ( 'border-top-width' === cssProperty || 'border-right-width' === cssProperty || 'border-bottom-width' === cssProperty || 'border-left-width' === cssProperty ) ) {
				styleThisSide = getCssValue( {
					cssSelector: cssSelectorCustom,
					cssProperty: cssProperty,
					responsiveSize: responsiveSize
				} )
			}

			if ( ! styleAllSides && ! styleThisSide ) {
				let cssPropertyToUse = 'border-style'
				if	( 'border-width' !== cssProperty ) {
					cssPropertyToUse = cssProperty.replace( '-width', '-style' )
				}
				//@todo: improve it by adding a temoporary <style> block
				const response = addCssRule( {
					selector: cssSelectorCustom,
					pseudoClass: cssCurrentPseudoClass,
					selectorFull: cssSelectorFull,
					cssProperty: cssPropertyToUse,
					cssValue: 'solid',
					cssUnit: ''
				} )

				if ( ! response.status ) {
					console.warning( response )
				}

				console.warn( '🎃 Stylist Error 415:' + response.message )
			}
		}

		this.pushCSSChangesThrottled()
	}

	pushCSSChangesThrottled = debounce( () => {
		const { selectedEl, cssSelectorFull, cssSelectorCustom, cssCurrentPseudoClass, cssProperty, currentSidebarPanel } = this.props;

		// Colapse 'Advanced' pannel when changin shorthand margin/padding property.
		if ( undefined !== currentSidebarPanel && currentSidebarPanel.includes( '/' )
				&& ( 'margin' === cssProperty || 'padding' === cssProperty || 'border-radius' === cssProperty ) ) {
			this.props.onPanelChange( cssProperty )
		}

		// Add new <style> element for the current cssProperty with updated value.
		if ( false !== this.state.currentValue ) {
			// ↑↑↑ Make sure to check agains false as 0 is a valid value!
			const response = addCssRule( {
				selector: cssSelectorCustom,
				pseudoClass: cssCurrentPseudoClass,
				selectorFull: cssSelectorFull,
				cssProperty: cssProperty,
				cssValue: this.state.currentValue,
				cssUnit: this.state.currentUnit
			} )

			if ( response.status ) {
				// window.stlst_legacy.delete_live_css()
				/**
				 * Once all done and CSS if in the main code block,
				 * check again if it works or it gets overriten by media queries.
				 */
				this.updateResponsiveNotice()
			} else {
				console.warn( '🎃 Stylist Error 450:' + response.message )
			}
		}
	}, 200, {
		leading: false,
		trailing: true
	} )

	render() {
		const { type, name, cssProperty, values, cssDefault, notice,
			advanced, cssSelectorCustom } = this.props;

		const containerId = `${ cssProperty }-control`,
			controlId = `stlst-${ cssProperty }-data`,
			controlClass = `stlst-control control-enabled__${ this.state.isEnabled } control-default__${ this.state.isDefault } stlst-option-group stlst-control-option`,
			inputId = `stlst-${ cssProperty }`,
			inputClass = `control-type__${ type } stlsr-control-hidden`

		const colors = [
			'#565D66', '#2390D1', '#0A558C', '#D170F5'
		]

		const isVissible = this.state.isVisible

		return (
			<div id={containerId}
				className={controlClass}
				data-css={cssProperty}>
				<div className="stlst-part">
					<Label
						isEnabled={this.state.isEnabled}
						onToggleEnabled={this.toggleEnabled}

						cssDefault={cssDefault}
						currentValue={this.state.currentValue}
						cssDefault={cssDefault}
						onToggleDefault={this.toggleDefault}>
						{name}
					</Label>

					{ ( () => {
						switch ( type ) {
							case 'select':
								return <div className="stlst-control-main stlst-control-main--select"><Select
									values={values}
									value={this.state.currentValue}
									changeValue={this.changeValue} /></div>;
							case 'radio':
								return <div className="stlst-control-main stlst-control-main--toollbar"><Toolbar
									controls={values.map( ( control ) => {
										const { value } = control;
										const isActive = ( this.state.currentValue === value );

										return {
											...control,
											isActive,
											onClick: () => this.changeValue( isActive ? null : value ),
										};
									}, this )} /></div>;
							case 'color':
								return <div className="stlst-control-main stlst-control-main--color"><ColorPalette
									colors={colors}
									currentValue={this.state.currentValue}
									changeValue={this.changeValue} /></div>;
							case 'font':
								return <div className="stlst-control-main stlst-control-main--font"><FontSelector
									value={this.state.currentValue}
									changeValue={this.changeValue} /></div>;
							case 'slider':
								return isVissible && <div className="stlst-control-main stlst-control-main--slider"><SliderControl
									cssProperty={cssProperty}
									cssDefault={cssDefault}
									notice={notice}
									value={this.state.currentValue} //this.currentValue()
									changeValue={this.changeValue}
									selectedEl={this.props.selectedEl}

									currentUnit={this.currentUnit()}
									changeUnit={this.changeUnit}
									advanced={advanced} /></div>;
							case 'upload':
								return <div className="stlst-control-main stlst-control-main--select"><UploadButton
									value={this.state.currentValue}
									changeValue={this.changeValue} /></div>;
							default:
								return 'NO CONTROL';
						}
					} )() }

					{	this.state.isEnabled &&
						! this.state.isDefault &&
						this.state.isResponsiveNotice &&
						<ResponsiveValueNotice
							cssProperty={cssProperty}
							controlType={type}
							cssSelectorCustom={cssSelectorCustom}
							onResponsiveModeToggle={this.props.onResponsiveModeToggle}
						/> }

				</div>

				<input id={inputId}
					type="text"
					className={inputClass}
					defaultValue={this.state.currentValue}
					onChange={this.onInputChange} />
				{/* ref={( input ) => this.input = input} */}
				{/* Uncontroled component element */}

				{notice}
			</div>
		)
	}
}

export default Control;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/control/index.jsx